module.exports = __webpack_public_path__ + "src/modules/home/training/images/1705.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/training/images/1705.png
// module id = 788
// module chunks = 0